import React from 'react'
import './Header.css'
import logo from './logo.png'
import SearchIcon from '@mui/icons-material/Search';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import {
    BrowserRouter as Router,
    Switch,
    Route,Link
    
  } from "react-router-dom";
import { useStateValue } from './StateProvider'
import { auth } from './firebase.js'

function Header() {
    const [{basket,user}, dispatch] = useStateValue();
const handleAuthentication=()=>{
    if(user){
        auth.signOut();
    }
}
    return (
        <div className='header'>
            <Link to="/">   <img className="header_logo" src={logo} alt="" /></Link>
            <div className="header_search">
                <input type="text" className="header_SearchInput" />
                <SearchIcon className="header_SearchIcon" />
            </div>
            <div className="header_nav">
            <Link to={!user && '/login'}> 
                <div onClick={handleAuthentication} className="header__options">
                    <span className="header__optionLineOne">Hello Guest</span>
                     <span className="header__optionLineTwo">
                         {user?'Sign Out':'Sign In'}</span> 
                </div>
                </Link>
                <div className="header__options">
                    <span className="header__optionLineOne">Retuens</span>
                    <span className="header__optionLineTwo">& orders</span>

                </div>
                <div className="header__options">
                    <span className="header__optionLineOne">Your</span>
                    <span className="header__optionLineTwo">Prime</span>

                </div>
            </div>
            <Link to="/Checkout"> 
            <div className="header_optionBasket">
            <ShoppingBasketIcon /> 
                <span className="header__optionLineTwo header_basketCount">{basket.length}</span>
            </div>
            </Link>
        </div>
    )
}

export default Header
